export const canManageProject = (role?: string | null): boolean =>
  role === 'PROJECT_MANAGER' || role === 'ADMIN_PROJECT_MANAGER' || role === 'ADMIN_MEMBER' || role === 'ADMIN_PM';

export const canAccessManageAccount = (role?: string | null): boolean =>
  role === 'ADMIN' || role === 'ADMIN_PROJECT_MANAGER' || role === 'ADMIN_MEMBER' || role === 'ADMIN_PM';
